import { render, staticRenderFns } from "./standalone-form.vue?vue&type=template&id=8be1eb86&scoped=true&"
import script from "./standalone-form.vue?vue&type=script&lang=ts&"
export * from "./standalone-form.vue?vue&type=script&lang=ts&"
import style0 from "./standalone-form.vue?vue&type=style&index=0&id=8be1eb86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8be1eb86",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VRow})
